import React from 'react'
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material'
import { useModelSelect } from './hooks'

export function ModelSelect() {
  const { selectedModelValue, selectedPrompt, setSelectedModel } =
    useModelSelect()

  return (
    <FormControl fullWidth size="small">
      <InputLabel id="model-select-label">Model</InputLabel>
      <Select
        labelId="model-select-label"
        id="model-select"
        value={selectedModelValue || ''}
        label="Model"
        onChange={(e: SelectChangeEvent) => setSelectedModel(e.target.value)}
        disabled={!selectedPrompt}
      >
        {selectedPrompt?.metadata.models.map((model) => (
          <MenuItem key={model} value={model}>
            {model}
          </MenuItem>
        )) || []}
      </Select>
    </FormControl>
  )
}
